import { Access } from "@/features/farmer/domain/farmer-interface";
// @ts-ignore
// import AccessDeny from "@assets/images/access-deny-l.png";

interface PrivateWidgetProps {
  access: Access[];
  route: string;
  children: JSX.Element;
}

const PrivateWidget = ({ access, route, children }: PrivateWidgetProps) => {
  let hasAccess = access.some((acc) => {
    return !!acc.children.find(({ name }) => name === route);
  });
  if (hasAccess) {
    return children;
  } else {
    return <></>;
    // return (
    //   <div className="flex flex-col gap-2 items-center justify-center w-[40%] whitespace-nowrap m-auto mt-2">
    //     <img alt="access-deny" src={AccessDeny} />
    //     دسترسی به این قسمت وجود ندارد
    //   </div>
    // );
  }
};

export default PrivateWidget;
